



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { INotificationHook } from "@/models/notifications";
import { ITemplate } from "@/models/templates";
import { DataModules } from "@/store/modules/data";

@Component
export default class AdminAutomationActionForm extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  @Prop({ default: undefined })
  public templateId!: ITemplate["id"];

  @Prop({ default: undefined })
  public channelCode!: NotificationChannelCodes;

  @Prop({ default: undefined })
  public hookId!: INotificationHook["id"];

  @Prop({ default: false })
  public isCreate!: boolean;

  // Data

  public notificationTemplate: ITemplate | null = null;

  // Life-cycle methods
  public async created() {
    try {
      this.notificationTemplate = await this.getNotificationTemplate();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  // Watch
  @Watch("templateId")
  public async onTemplateChange() {
    this.notificationTemplate = await this.getNotificationTemplate();
  }

  // Computed

  public get isEmailTemplate() {
    return (
      this.notificationTemplate?.channel?.code ===
      NotificationChannelCodes.EMAIL
    );
  }

  // Methods

  public getNotificationTemplate() {
    if (!this.templateId) return null;
    return this.$store.dispatch(`data/${DataModules.TEMPLATES}/get`, {
      id: this.templateId,
      vm: this,
      storeData: false,
      params: {
        with:
          "contents,category.params,mappings.hook,recipient_type.category.params,channel"
      }
    });
  }

  public get title() {
    if (this.isCreate) {
      return this.$t("_action.create_object", {
        object: (this.$t("_.automation_action") as string).toLowerCase()
      });
    } else {
      return this.$t("_.manage_automation_action");
    }
  }
}
